import { motion } from "framer-motion";
import { Link2, Wand2, MailCheck } from "lucide-react";

const steps = [
  { n: "01", icon: Link2, title: "Paste your link + brand vibe", desc: "Share your product or service page URL, drop your logo and brand guidelines. Takes 2 minutes.", testid: "step-card-1" },
  { n: "02", icon: Wand2, title: "We craft your viral reel", desc: "Our creator team + AI engine turn it into a scroll-stopping 9:16 hook, edited for Instagram. Within 24 hours.", testid: "step-card-2" },
  { n: "03", icon: MailCheck, title: "Delivered to your inbox", desc: "Get an HD, ready-to-post reel link by email. Download, post, go viral. Full rights, yours forever.", testid: "step-card-3" },
];

export const HowItWorks = () => (
  <section id="how-it-works" data-testid="how-it-works-section" className="py-16 lg:py-24">
    <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12">
      <div className="max-w-2xl">
        <p className="text-xs font-mono uppercase tracking-widest text-[#00F5D4] mb-3">The process</p>
        <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight">
          From link to viral reel in three steps
        </h2>
      </div>

      <div className="mt-12 grid md:grid-cols-3 gap-5">
        {steps.map((s, i) => (
          <motion.div key={s.n} data-testid={s.testid}
            initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
            transition={{ duration: 0.45, delay: i * 0.1 }}
            className="group relative rounded-2xl bg-[#12141C] border border-white/10 p-7 hover:border-[#FF2E63]/40 hover:bg-[#1A1D29] transition-colors">
            <span className="font-mono text-5xl font-bold text-white/5 group-hover:text-[#FF2E63]/20 transition-colors">{s.n}</span>
            <div className="mt-2 w-11 h-11 grid place-items-center rounded-xl bg-[#FF2E63]/10 border border-[#FF2E63]/20">
              <s.icon className="w-5 h-5 text-[#FF2E63]" />
            </div>
            <h3 className="mt-5 font-display text-xl font-semibold">{s.title}</h3>
            <p className="mt-2 text-sm text-slate-400 leading-relaxed">{s.desc}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
